import { BrowserTitleService } from '../services/BrowserTitleService';

export interface IObjectNameScope extends ng.IScope {
  objectName: string;
}

export function setBrowserTitleCtrl(place: string) {
  return [
    '$scope',
    'BrowserTitleService',
    ($scope: IObjectNameScope, BrowserTitleService: BrowserTitleService) => {
      BrowserTitleService.setTitleWithPlaceEntityNameAndSubplaceName({placeEntityName: $scope.objectName, translatableSubplaceName: place});
    }
  ];
}
